var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B1E5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0005 10C17.7914 10 16.0005 11.7909 16.0005 14H14.6489C13.1359 14 11.8597 15.1266 11.672 16.6279L10.422 26.6279C10.1982 28.4185 11.5944 30 13.3989 30H26.6022C28.4067 30 29.8028 28.4185 29.579 26.6279L28.329 16.6279C28.1414 15.1266 26.8652 14 25.3522 14H24.0005C24.0005 11.7909 22.2097 10 20.0005 10ZM22.0005 16V17C22.0005 17.5523 22.4483 18 23.0005 18C23.5528 18 24.0005 17.5523 24.0005 17V16H25.3522C25.8565 16 26.2819 16.3755 26.3445 16.876L27.5945 26.876C27.6691 27.4728 27.2037 28 26.6022 28H13.3989C12.7974 28 12.332 27.4728 12.4066 26.876L13.6566 16.876C13.7192 16.3755 14.1446 16 14.6489 16H16.0005V17C16.0005 17.5523 16.4483 18 17.0005 18C17.5528 18 18.0005 17.5523 18.0005 17V16H22.0005ZM22.0005 14C22.0005 12.8954 21.1051 12 20.0005 12C18.896 12 18.0005 12.8954 18.0005 14H22.0005Z",
    fill: "#1A1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.0218caa303d6d4b06d8e8b7f28f1d1c0.svg";
export { ForwardRef as ReactComponent };